/**
 * Date utilities for local timezone handling
 *
 * These functions ensure dates are handled in the user's local timezone (GMT+7)
 * rather than UTC, which is important for "today" comparisons.
 */

/**
 * Get a date string in YYYY-MM-DD format using LOCAL timezone
 * This is the correct way to get "today" for users in any timezone
 */
export function getLocalDateString(date: Date = new Date()): string {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

/**
 * Add days to a date string and return new date string in LOCAL timezone
 */
export function addDaysToDate(dateStr: string, days: number): string {
	const date = new Date(dateStr + 'T00:00:00');
	date.setDate(date.getDate() + days);
	return getLocalDateString(date);
}

/**
 * Get Monday of the week for a given date (LOCAL timezone)
 */
export function getWeekStart(dateStr: string): string {
	const date = new Date(dateStr + 'T00:00:00');
	const day = date.getDay();
	const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust for Sunday
	date.setDate(diff);
	return getLocalDateString(date);
}

/**
 * Get Sunday of the week for a given date (LOCAL timezone)
 */
export function getWeekEnd(dateStr: string): string {
	const start = new Date(getWeekStart(dateStr) + 'T00:00:00');
	start.setDate(start.getDate() + 6);
	return getLocalDateString(start);
}
